import {createStyles, rem, Tooltip} from '@mantine/core';
import React from 'react';

import {ZINDEX_FLOATING_UI} from 'styles/StyleConstants';
import Chip, {ChipSize} from 'ui-library/chips/Chip';

import {getRawModelInputChipDisplayLabel, type RawPredictionInputComponent} from './BulkPredictionUtils';

export interface RawModelInputChipProps {
  component: RawPredictionInputComponent;
}

export default function RawModelInputChip({component}: RawModelInputChipProps): JSX.Element {
  const {classes} = useRawModelInputChipTooltipStyles();
  const displayLabel = getRawModelInputChipDisplayLabel(component);

  return (
    <Tooltip
      label={component.value}
      multiline={true}
      withinPortal={true}
      zIndex={ZINDEX_FLOATING_UI}
      classNames={{tooltip: classes.tooltip}}
    >
      <span className={classes.focusTarget}>
        <Chip size={ChipSize.SMALL} text={displayLabel} isReadonly={true} />
      </span>
    </Tooltip>
  );
}

const useRawModelInputChipTooltipStyles = createStyles(() => ({
  focusTarget: {
    display: 'inline-flex',
  },
  tooltip: {
    maxWidth: rem(420),
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-all',
  },
}));
